import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	unavailable: {
		alignItems: 'center',
		color: '#858585',
		display: 'flex',
		flexDirection: 'column',
		fontSize: 18,
		height: '100%',
		justifyContent: 'center',
		...CssSelectors.allChildren(
			{
				marginBottom: 40,
			},
			':not(:last-child)'
		),
	},
});
